import { TQuerySpecial, TSpecialDeal } from '@src/modules/special-deal'
import { TResApi } from '@src/configs/interface.config'

import { request } from './config'

export const CreateSpecialDeal = (data: TSpecialDeal) => request({ url: 'special-deal', method: 'POST', data })
export const getLisSpecialDeal = (params: TQuerySpecial, token: string) =>
  request({ url: 'special-deal', method: 'GET', params }, { token })
export const removeSpecialDealById = (id: string) => request({ url: `special-deal/${id}`, method: 'DELETE' })
export const getSpecialDealById = (id: string, token: string) =>
  request({ url: `special-deal/${id}`, method: 'GET' }, { token })
export const patchSpecialDealById = (id: string, data: TSpecialDeal) =>
  request({ url: `special-deal/${id}`, method: 'PATCH', data })
export const removeSpecialDealByIds = (ids: string[]) =>
  request({ url: 'special-deal/delete-many', method: 'POST', data: { ids } })
export const getSpecialDealTotal = (token: string) => request({ url: 'special-deal/total', method: 'GET' }, { token })
export const importData = (data: FormData): Promise<TResApi<TSpecialDeal[]>> =>
  request({
    url: `special-deal/upload-data`,
    method: 'POST',
    data,
    headers: {
      Accept: 'application/xml, text/plain, text/html, *.*',
      'Content-Type': 'multipart/form-data, application/x-www-form-urlencoded;charset=utf-8',
    },
    transformRequest: [() => data],
  })
